<!-- ContentPage 接收一个底部tab，根据底部tab来渲染页面 -->
<!-- 主要是根据type来渲染页面 -->
<template>
    <div v-if="bottomTabObj">
        <!-- 导航栏区域 -->
        <NavigationBarView :bottomTab="bottomTabObj" @onItemClick="onTabItemClick" />
        <div class="navigationbar-edit" @click="onClickNavigationBar($event, bottomTabObj)">编辑导航栏</div>
        <!-- 内容区域 -->
        <div class="general-content-box">
            <ComponentListPage v-if="currentTab && currentTab.type == 'component_list'"
                :component_list_config="currentTab.component_list_config" />
            <WallpaperListPage class="general-content-box" v-else-if="currentTab && currentTab.type == 'wallpaper_list'"
                :wallpaper_list_config="currentTab.wallpaper_list_config" />
        </div>
    </div>
</template>

<script>
import emitter from '@/utils/eventbus'

import NavigationBarView from '@/views/Decoration//DecorationGroup/NavigationBar/NavigationBarView.vue'
import ComponentListPage from './ComponentListPage.vue'
import WallpaperListPage from './WallpaperListPage.vue'

export default {
    name: "GeneralPageView",
    props: ['bottomTab'],
    components: {
        NavigationBarView,
        ComponentListPage,
        WallpaperListPage
    },
    data() {
        return {
            bottomTabObj: this.bottomTab,
            currentTab: this.bottomTab.navigationbar.tabs.length > 0 ? this.bottomTab.navigationbar.tabs[0] : null
        }
    },
    methods: {
        /**
         * 点击item选项
         */
        onTabItemClick(index) {
            console.log('选项', index)
            this.currentTab = this.bottomTabObj.navigationbar.tabs[index]
        },
        onClickNavigationBar(event, bottomtab) {
            console.log('点击编辑导航栏', bottomtab)
            emitter.emit('onComponentChange', { type: 'navigationbar', name: '导航栏', component: bottomtab })
        },
        getCurrentTab() {
            return this.currentTab
        }
    },
    watch: {
        bottomTabObj(newValue) {
            if (this.bottomTabObj.navigationbar.tabs.length > 0) {
                this.currentTab = newValue.navigationbar.tabs[0]
            }
        }
    }
}
</script>
  
<style scoped lang="less">
.navigationbar-edit {
    position: absolute;
    left: 100%;
    top: 0px;
    height: 32px;
    line-height: 32px;
    background: rgba(221, 240, 215, 0.4);
    border-radius: 16px;
    padding: 0 16px;
    word-break: keep-all;
    white-space: nowrap;
    font-size: smaller;
    transform: translateX(8px);
    color: #6B7075;
    cursor: pointer;
}

.general-content-box {
    width: 100%;
    height: calc(100% - 40px);
}
</style>